export const replaceSpaceOnPlus = (value) => {
    return value.replace(/\s/, "+")
};